import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Check, CornerDownRight, MoreHorizontal, Pencil, Play, Trash2 } from "lucide-react";
import "./ComposerQueue.css";

export default function ComposerQueue({ items, enabled, busy, running, onGuide, onSend, onEdit, onRemove, onToggle, onEditingChange }) {
  const [menu, setMenu] = useState(null);
  const [editing, setEditing] = useState(null);
  const [draft, setDraft] = useState("");
  const root = useRef(null);
  useEffect(() => { onEditingChange?.(Boolean(editing)); }, [editing, onEditingChange]);
  useEffect(() => { if (editing && !items.some(item => item.id === editing)) setEditing(null); }, [items, editing]);
  useEffect(() => {
    const close = event => { if ((!root.current?.contains(event.target) && !event.target?.closest?.(".composer-queue-menu")) || event.key === "Escape") { setMenu(null); setEditing(null); } };
    document.addEventListener("pointerdown", close);
    document.addEventListener("keydown", close);
    return () => { document.removeEventListener("pointerdown", close); document.removeEventListener("keydown", close); };
  }, []);
  if (!items.length) return null;
  const menuItem = items.find(item => item.id === menu?.id);
  return <><div className="composer-queue" ref={root} aria-label="待发送消息">
    {items.map(item => <div className="composer-queue-row" key={item.id}>
      <CornerDownRight size={16} aria-hidden="true" />
      {editing === item.id ? <form className="composer-queue-edit" onSubmit={async event => {
        event.preventDefault(); if (draft.trim() && await onEdit(item, draft.trim()) !== false) setEditing(null);
      }}><textarea aria-label="编辑排队消息" autoFocus value={draft} maxLength={8000} onChange={event => setDraft(event.target.value)} />
        <button type="submit" className="icon-button" aria-label="保存排队消息" title="保存" disabled={!draft.trim()}><Check size={16} /></button></form>
        : <div className="composer-queue-content"><span>{item.content}</span>
          {item.state === "uncertain" && <small>发送状态待确认</small>}</div>}
      <div className="composer-queue-actions">
        <button type="button" className="composer-queue-guide" disabled={busy || editing === item.id}
          onClick={() => running ? onGuide(item) : onSend(item)} title={running ? "引导当前任务" : "发送这条消息"}>
          {running ? <CornerDownRight size={15} /> : <Play size={14} />}<span>{item.state === "uncertain" ? "确认" : running ? "引导" : "发送"}</span>
        </button>
        <button type="button" className="icon-button" onClick={() => onRemove(item)} disabled={busy || item.state === "uncertain"}
          aria-label="删除排队消息" title="删除排队消息"><Trash2 size={15} /></button>
        <button type="button" className="icon-button" onClick={event => {
          const rect = event.currentTarget.getBoundingClientRect();
          setMenu(menu?.id === item.id ? null : { id: item.id, top: Math.max(12, rect.top-100), left: Math.max(12, Math.min(window.innerWidth-192, rect.right-180)) });
        }}
          aria-label="排队消息选项" title="更多选项"><MoreHorizontal size={17} /></button>
      </div>
    </div>)}
  </div>{menuItem && createPortal(<div className="composer-queue-menu" role="menu" style={{ top: menu.top, left: menu.left }}>
    <button type="button" role="menuitem" disabled={busy || menuItem.state === "uncertain"} onClick={() => {
      setEditing(menuItem.id); setDraft(menuItem.content); setMenu(null);
    }}><Pencil size={15} />编辑消息</button>
    <button type="button" role="menuitem" onClick={() => { onToggle(); setMenu(null); }}>
      <CornerDownRight size={15} />{enabled ? "关闭自动排队" : "开启自动排队"}</button>
  </div>, document.body)}</>;
}
